import { FC } from "react";
import LensIcon from "@mui/icons-material/Lens";
import { Stack, Typography } from "@mui/material";
import useFetchStructureData from "src/Pages/Company/OrganizationStructure/api/useFetchStructureData";
import __ from "src/utils/Translations";

interface IHeaderInfo {
  companyId: string;
  structureId: string;
}

const HeaderInfo: FC<IHeaderInfo> = ({ companyId, structureId }) => {
  const { data, isLoading } = useFetchStructureData(companyId, structureId!);

  const visibility = data?.visible;
  const name = data?.name;

  return (
    <>
      <Typography
        variant="h4"
        fontWeight="fontWeightBold"
        textTransform="uppercase"
      >
        {__("Struktura")} {name}
      </Typography>
      <Typography
        variant="body2"
        fontWeight="fontWeightMedium"
        textTransform="uppercase"
        sx={{ margin: "8px 0" }}
      >
        {__("Panel Administracyjny")}
      </Typography>
      <Stack flexDirection="row" alignItems="center" my={1}>
        <LensIcon
          sx={{
            // eslint-disable-next-line no-nested-ternary
            fill: isLoading ? "grey" : visibility ? "green" : "red",
            marginRight: "8px",
          }}
        />
        <Typography>
          {/* eslint-disable-next-line no-nested-ternary */}
          {isLoading
            ? __("Ładowanie")
            : visibility
            ? __("Struktura widoczna")
            : __("Struktura niewidoczna")}
        </Typography>
      </Stack>
    </>
  );
};
export default HeaderInfo;
